var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mkt-product-preview",on:{"click":_vm.eventEmitClick}},[_c('mkt-icon',{attrs:{"tx-icon":"icon-search2","tx-font-size":"26px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }